import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Languages } from 'src/app/models/Configurations/Languages';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'language-option-box',
  templateUrl: './language-option-box.component.html',
  styleUrls: ['./language-option-box.component.scss']
})
export class LanguageOptionBoxComponent implements OnInit {

  @Output() languageChanged = new EventEmitter<Languages>();

  get languages(): Languages[] {
    return this.configService.languages;
  }

  get currentLanguageCompany(): Languages | null {
    return this.languages.find(x => x.code == this.sessionService.getDetails().language) ?? null;
  }

  constructor(private configService: ConfigurationService,
    private sessionService: SessionService) {
  }

  ngOnInit(): void {
  }

  languageSelected(value: Languages) {
    if (Object.keys(value).length) {
      this.languageChanged.emit(value);
    }
  }
}
